import React, { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Button } from "antd"; // Using Ant Design Input for better UI consistency
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "../../../../Components/UI/Input";
import dayjs from "dayjs";
const Experience = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const experienceDetails = watch("workExperienceDetails") || [];

  const addExperienceRow = () => {
    const newExperience = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      department: "",
      designation: "",
      weFromdate: "",
      weTodate: "",
      salary: "",
      remarks: "",
      image: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("workExperienceDetails", [...experienceDetails, newExperience]);
  };

  const removeExperience = (index) => {
    const updatedExperience = experienceDetails.filter((_, i) => i !== index);
    setValue("workExperienceDetails", updatedExperience);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
          type="button"
          onClick={addExperienceRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>

      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Department</th>
              <th>Designation</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Salary</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {experienceDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button
                      type="danger"
                      onClick={() => removeExperience(index)}
                    >
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].department`}
                      type="text"
                      placeholder="Department"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.department
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>
                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].designation`}
                      type="text"
                      placeholder="Designation"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.department
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>

                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].weFromdate`}
                      type="date"
                      placeholder="Work Experiece From"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.weFromdate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`workExperienceDetails[${index}].weFromdate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                    />
                  </td>
                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].weTodate`}
                      type="date"
                      placeholder="Work Experiece To"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.weTodate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`workExperienceDetails[${index}].weTodate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                    />
                  </td>
                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].salary`}
                      type="number"
                      placeholder="Salary"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.salary
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>
                  <td>
                    <Input
                      name={`workExperienceDetails[${index}].remarks`}
                      type="text"
                      placeholder="Remarks"
                      className={`form-control ${
                        errors?.workExperienceDetails?.[index]?.remarks
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Experience;
